export default __webpack_public_path__ + "static/media/ic_bookmark.d9205146.svg";